"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, Modal, ModalBody, ModalHeaderTitle, TextDisplay } from "@opensea/ui-kit";
import { useCallback } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { AnimatedLogo } from "../../components/AnimatedLogo";
import { useConnect } from "../../polychain/hooks/useConnect";
import { ConnectModalActions, ConnectModalState } from "../../stores/connectModalStore";
import { FlowActions, FlowState } from "../../stores/flowStore";
import { useIsFlowActive } from "../hooks/useIsFlowActive";
import { ConnectModal } from "./ConnectModal";
export const ConnectFlow = () => {
  const $ = _c(10);
  const {
    flow
  } = useSnapshot(FlowState);
  const connectFlow = flow?.type === "connect" ? flow : undefined;
  const open = useIsFlowActive("connect");
  const {
    step
  } = useSnapshot(ConnectModalState);
  let t0;
  if ($[0] !== connectFlow) {
    t0 = (connectedAddress, connectedChain, connector) => {
      if (!connectFlow) {
        return;
      }
      FlowActions.onSuccess();
      FlowActions.endFlow();
      connectFlow.onConnected?.(connectedAddress, connectedChain, connector);
      ConnectModalActions.reset();
      FlowActions.startFlow({
        type: "authenticate",
        autoPromptSiwe: true,
        onAuthenticated: connectFlow.onAuthenticated
      });
    };
    $[0] = connectFlow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onConnected = t0;
  let t1;
  if ($[2] !== onConnected) {
    t1 = {
      onConnected
    };
    $[2] = onConnected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useConnect(t1);
  const t2 = connectFlow?.switchOnConnect;
  let t3;
  if ($[4] !== t2) {
    t3 = <ConnectFlowModalContent switchOnConnect={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = step.id !== "pick-login-option" ? _temp : undefined;
  let t5;
  if ($[6] !== open || $[7] !== t3 || $[8] !== t4) {
    t5 = <Modal className="md:rounded-xl" content={t3} onBack={t4} onOpenChange={_temp2} open={open} size="sm" withCloseIcon={true} />;
    $[6] = open;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const ConnectFlowModalContent = t0 => {
  const $ = _c(14);
  const {
    switchOnConnect,
    onConnected,
    isLinking,
    title
  } = t0;
  const {
    title: titleState
  } = useSnapshot(ConnectModalState);
  const t = useTranslations("wallet.ConnectFlow");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CenterAligned className="mb-6"><AnimatedLogo /></CenterAligned>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t || $[2] !== title || $[3] !== titleState) {
    t2 = title ?? t(titleState);
    $[1] = t;
    $[2] = title;
    $[3] = titleState;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <TextDisplay asChild={true} className="mb-8 text-center" size="sm"><ModalHeaderTitle>{t2}</ModalHeaderTitle></TextDisplay>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isLinking || $[8] !== onConnected || $[9] !== switchOnConnect) {
    t4 = <ConnectModal isLinking={isLinking} onConnected={onConnected} switchOnConnect={switchOnConnect} />;
    $[7] = isLinking;
    $[8] = onConnected;
    $[9] = switchOnConnect;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <ModalBody className="scrollbar-hidden pt-12 pb-6">{t1}{t3}{t4}</ModalBody>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp() {
  ConnectModalActions.setStep({
    id: "pick-login-option"
  });
}
function _temp2(open_0) {
  if (!open_0) {
    FlowActions.endFlow();
  }
}